

































import { Component, Prop, Vue } from "vue-property-decorator";
import EstimatePurchaseRow from "./EstimatePurchaseRow.vue";
import VTh from "./VTh.vue";

@Component({
  components: {
    VTh,
    EstimatePurchaseRow
  }
})
export default class PurchaseOptionHeader extends Vue {
  @Prop({ required: true }) isShowNoteColumn!: boolean;
  @Prop({ default: false }) isRouteActualResult!: boolean;

  budgetColumnSpan = 5;
  columnHeaders: { show: boolean; label: string; css?: string }[] = [
    {
      show: true,
      label: "大項目"
    },
    {
      show: true,
      label: "中項目"
    },
    {
      show: true,
      label: "小項目"
    },
    {
      show: true,
      label: "経費カテゴリ"
    },
    {
      show: true,
      label: "数量"
    },
    {
      show: true,
      label: "単位"
    },
    {
      show: true,
      label: "単価"
    },
    {
      show: true,
      label: "見積金額"
    },
    {
      show: this.isShowNoteColumn,
      label: "備考"
    },
    { show: true, label: "発注単価" },
    { show: true, label: "発注金額" },
    { show: true, label: "利益額" },
    { show: true, label: "利益率" },
    {
      show: true,
      label: "発注先",
      css: this.isRouteActualResult ? "margin-right: -0.25rem" : ""
    }
  ];

  get columns() {
    return this.columnHeaders
      .map(header => ({
        ...header,
        show: header.label === "備考" ? this.isShowNoteColumn : header.show
      }))
      .filter(column => column.show);
  }

  get spanValue(): string {
    if (this.isRouteActualResult) {
      return `span ${this.columns.length + 1}`;
    }
    return `span ${this.columns.length - this.budgetColumnSpan}`;
  }
}
